import { DatePill } from "../../../shared/components";
import type { Period } from "../../types";
import styles from "./DateRangeToolbar.module.css";

const PERIODS: { value: Period; label: string }[] = [
  { value: "daily", label: "D" },
  { value: "weekly", label: "W" },
  { value: "monthly", label: "M" },
];

export interface DateRangeToolbarProps {
  fromDate: string;
  toDate: string;
  period: Period;
  isDatePickerOpen: boolean;
  onDatePickerOpenChange: (open: boolean) => void;
  onDateChange: (from: string | null, to: string | null) => void;
  onPeriodChange: (period: Period) => void;
}

export function DateRangeToolbar({
  fromDate,
  toDate,
  period,
  isDatePickerOpen,
  onDatePickerOpenChange,
  onDateChange,
  onPeriodChange,
}: DateRangeToolbarProps) {
  return (
    <div className={styles.toolbar}>
      <DatePill
        dateFrom={fromDate}
        dateTo={toDate}
        isOpen={isDatePickerOpen}
        onOpenChange={onDatePickerOpenChange}
        onChange={onDateChange}
      />
      <div className={styles.periodToggle} role="radiogroup" aria-label="Period granularity">
        {PERIODS.map(({ value, label }) => (
          <button
            key={value}
            type="button"
            className={styles.periodButton}
            data-active={period === value}
            aria-checked={period === value}
            role="radio"
            onClick={() => onPeriodChange(value)}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
}
